import { render, staticRenderFns } from "./Spots.vue?vue&type=template&id=76a228a0"
import script from "./Spots.vue?vue&type=script&lang=js"
export * from "./Spots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports